import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { selectCurrentLocation } from '../../../stores/locations/locations.selector';
import { RoomAddModalConfirmed } from '../../../stores/rooms/rooms.actions';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-room-add-modal',
  templateUrl: './room-add-modal.component.html',
  imports: [ReactiveFormsModule, FormsModule],
})
export class RoomAddModalComponent {
  private readonly store = inject(Store);
  public readonly activeModal = inject(NgbActiveModal);

  public roomNumberForm: UntypedFormControl = new UntypedFormControl('');

  private readonly location = this.store.selectSignal(selectCurrentLocation);

  onSubmit() {
    const roomNumber = this.roomNumberForm.value;
    if (!roomNumber) {
      return;
    }

    const location = this.location();
    if (!location) {
      return;
    }

    this.store.dispatch(
      new RoomAddModalConfirmed({
        Room: roomNumber,
        HotelCode: location.HotelCode,
        CheckedIn: false,
      })
    );
    this.roomNumberForm.reset();
    this.activeModal.close();
  }
}
